import {createGeneralPageEventsAndComponents} from "../technical/page-general";

window.addEventListener('DOMContentLoaded', () => {
	createGeneralPageEventsAndComponents();
});
